import { readable, type Readable, type Updater } from 'svelte/store';

function noop() {}

type Stores<T> = Readable<T> | [Readable<T>, ...Array<Readable<T>>] | Array<Readable<T>>;

// derived와 거의 비슷한 동작을 하지만, subscriber가 없어도 value가 cleanup이 되지 않는다.
export function immediateDerived<T, V>(
  stores: Stores<T>,
  // eslint-disable-next-line
  fn: (values: T, set: (value: V) => void, update: (updater: Updater<V>) => void) => V | Function,
  initialValue: V,
): Readable<V> {
  const single = !Array.isArray(stores);
  const storesArray = single ? [stores] : stores;
  if (!storesArray.every(Boolean)) {
    throw new Error('derived() expects stores as input, got a falsy value');
  }
  const auto = fn.length < 2;
  let started = false;

  return readable(initialValue, (set, update) => {
    if (started) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const values: any[] = [];
    let pending = 0;
    // eslint-disable-next-line
    let cleanup: Function = noop;
    const sync = () => {
      // console.log('try sync, pending', pending);
      if (pending) {
        return;
      }
      // console.log('sync');
      cleanup();
      const result = fn(single ? values[0] : values, set, update);
      // console.log(result);
      if (auto) {
        set(result as V);
      } else {
        cleanup = typeof result === 'function' ? result : noop;
      }
    };
    const unsubscribers = storesArray.flatMap((store, i) =>
      store.subscribe(
        (value) => {
          values[i] = value;
          pending &= ~(1 << i);
          // console.log('remove pending', pending.toString(2));
          if (started) {
            sync();
          }
        },
        () => {
          pending |= 1 << i;
          // console.log('add pending', pending.toString(2));
        },
      ),
    );
    started = true;
    sync();
    return function stop() {
      unsubscribers.forEach((unsubcribe) => unsubcribe());
      cleanup();
      // started = false 제거
    };
  });
}
